<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="jobsite.JobsiteNumber + ' - ' + jobsite.JobsiteName + ' :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
                        <router-link :to="`/jobsites`">
                            <i class="fa fa-building"></i> Jobsites
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">
                        <jobsite-name :jobsite="jobsite" />
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-8 col-lg-12">
                    <div class="card mb-4">
                        <h6 class="card-header">
                            <strong>Jobsite</strong>

                            <span class="pull-right">
                                <template v-if="this.$root.hasPermission('jobsites.manage')">
                                    <router-link :to="`/jobsites/edit/${jobsite.JobsiteId}`" class="btn btn-sm btn-light">
                                        <i class="fa fa-edit"></i> Edit
                                    </router-link>
                                    <router-link :to="`/jobsites/merge/${jobsite.JobsiteId}`" class="btn btn-sm btn-light">
                                        <i class="fa fa-copy"></i> Merge &amp; Delete
                                    </router-link>
                                </template>
                                <a :href="`/subcontractors/map?JobsiteId=${jobsite.JobsiteId}`" class="btn btn-sm btn-primary" target="_blank">Launch Subcontractor Map</a>
                            </span>
                        </h6>
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-md-3 text-muted text-md-right">Client:</div>
                                <div class="col-md-9">
                                    <router-link :to="`/clients/view/${jobsite.client_id}`" v-if="jobsite.client_id">{{ jobsite.client_name }}</router-link>
                                    <span v-else>--</span>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-3 text-muted text-md-right">Jobsite Name:</div>
                                <div class="col-md-9">
                                    {{ jobsite.JobsiteName }}
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-3 text-muted text-md-right">Jobsite Number:</div>
                                <div class="col-md-9">
                                    {{ jobsite.JobsiteNumber }}
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-3 text-muted text-md-right">Division:</div>
                                <div class="col-md-9">
                                    {{ jobsite.division_code }} - {{ jobsite.DivisionName }}
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-3 text-muted text-md-right test">Active:</div>
                                <div class="col-md-9">
                                    <span class="badge badge-success" v-if="jobsite.IsActive == 1">Active</span>
                                    <span class="badge badge-warning" v-else>Inactive</span>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-3 text-muted text-md-right">General Contractor:</div>
                                <div class="col-md-9">
                                    <template v-if="jobsite.general_contractor">{{ jobsite.general_contractor }}</template>
                                    <span v-else>--</span>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-3 text-muted text-md-right">Created:</div>
                                <div class="col-md-9" v-if="jobsite.created_at">
                                    {{ jobsite.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-3 text-muted text-md-right">Last Updated:</div>
                                <div class="col-md-9" v-if="jobsite.updated_at">
                                    {{ jobsite.updated_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-4">
                        <div class="card-header">Notes</div>
                        <div class="card-body">
                            <div v-if="jobsite.Description" v-html="jobsite.Description"></div>
                            <p v-else>
                                -- None --
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-12">
                    <div class="card mb-4">
                        <div class="card-header"><i class="fa fa-globe"></i> Address</div>
                        <div class="card-body">
                            <template v-if="jobsite.Address || jobsite.Address2 || jobsite.City || jobsite.State || jobsite.Zip">
                                <blockquote>
                                    {{ jobsite.Address }} {{ jobsite.Address2 }}<br>
                                    {{ jobsite.City }}<span v-if="jobsite.City && jobsite.State">,&nbsp;</span>{{ jobsite.State }} {{ jobsite.Zip }}
                                </blockquote>
                                <hr/>
                                <iframe :src="googleMap" frameborder="0" style="border:0"></iframe>
                            </template>
                            <template v-else>
                                -- No Address On File --
                            </template>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">
                            <button class="btn btn-sm btn-default" v-on:click="show_avg_filters = !show_avg_filters" title="Show/Hide Filters"><i class="fa fa-filter"></i>
                            <span class="badge" style="background-color: #d9534f" :title="`${filterCount} Filter(s) Applied`" v-if="filterCount > 0">{{ filterCount }}</span>
                            </button>
                            Avg Inspection Score:
                        </div>
                        <div class="card-body">
                            <template v-if="!loading_score">
                                <inspection-score :data="totals" :displayType="'badge'" :extraStyles="'font-size: 18px;'"></inspection-score>
                            </template>
                            <span v-else>
                                <i class="fa fa-spin fa-spinner"></i> Calculating Score
                            </span>

                            <div v-show="show_avg_filters" class="mt-3">
                                <div>
                                    <date-range-selector buttonTitle="Inspection Date Range" v-model="filters.InspectionDate" />
                                </div>
                                <div class="mt-1">
                                    <select v-model="filters.InspectionFormId" class="form-control table-filter">
                                        <option :value="null">-- All Forms --</option>
                                        <option v-for="form in forms" :value="form.inspection_form_id">{{ form.form_name }}</option>
                                    </select>
                                </div>
                                <div class="mt-2">
                                    <a href="javascript:void(0)" v-on:click="show_avg_filters = !show_avg_filters" title="Hide Filters">
                                        <i class="fa fa-remove"></i> Close Filters
                                    </a>
                                    <a href="javascript:void(0)" class="text-danger pull-right" v-on:click="clearFilters()" title="Clear Filters">
                                        <i class="fa fa-trash"></i> Clear Filters
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <drive-asset-list :assetType="'Jobsite'" :assetId="parseInt(JobsiteId)" :canEdit="this.$root.hasPermission('jobsites.manage')" />
                </div>
            </div>

            <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4 d-lg-flex d-none">
                <b-nav-item :active="curTab === 'incidents'" @click="curTab = 'incidents'" v-if="this.$root.hasPermission(['incidents.view.browse', 'incidents.view.own'])">
                    <i class="fa fa-stethoscope"></i> Incidents
                </b-nav-item>
                <b-nav-item :active="curTab === 'inspections'" @click="curTab = 'inspections'" v-if="this.$root.hasPermission(['inspections.view.browse', 'inspections.view.own'])">
                    <i class="fa fa-list"></i> Insp ({{ insp_count }}) &amp; Obsv ({{ obsv_count }})
                </b-nav-item>
                <b-nav-item :active="curTab === 'equipment'" @click="curTab = 'equipment'" v-if="this.$root.hasPermission('equipment.view')">
                    <i class="fa fa-truck"></i> Equipment
                </b-nav-item>
                <b-nav-item :active="curTab === 'jsa'" @click="curTab = 'jsa'" v-if="this.$root.hasPermission('jsa.view.browse')">
                    <i class="fa fa-files-o"></i> JSAs
                </b-nav-item>
                <b-nav-item :active="curTab === 'meetings'" @click="curTab = 'meetings'" v-if="this.$root.hasPermission(['safety.meetings.view.browse', 'safety.meetings.view.own'])">
                    <i class="fa fa-life-ring"></i> Safety Meetings
                </b-nav-item>
                <b-nav-item :active="curTab === 'data_sheets'" @click="curTab = 'data_sheets'" v-if="this.$root.hasPermission(['safety.data_sheets.view'])">
                    <i class="fa fa-files-o"></i> SDS ({{ sheet_count }})
                </b-nav-item>
                <b-nav-item :active="curTab === 'employees'" @click="curTab = 'employees'" v-if="this.$root.hasPermission(['employees.view'])">
                    <i class="fa fa-group"></i> Employees <span v-if="emp_count">({{ emp_count }})</span>
                </b-nav-item>

                <b-nav-item-dropdown :active="curTab === 'training_courses' || curTab === 'qr_code'" right title="More Jobsite Resources: QR Check In, Training Courses, Etc.">
                    <template slot="button-content">
                        <i class="fa fa-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item @click="curTab = 'insurance'">
                        <i class="fa fa-shield"></i> Insurance ({{ insurance_count }})
                    </b-dropdown-item>
                    <b-dropdown-item @click="curTab = 'qr_code'">
                        <i class="fa fa-qrcode"></i> QR Check In/Out
                    </b-dropdown-item>
                    <b-dropdown-item @click="curTab = 'training_courses'" v-if="this.$root.hasPermission(['training_courses.view'])">
                        <i class="fa fa-graduation-cap"></i> Training Courses
                    </b-dropdown-item>
                    <b-dropdown-item @click="curTab = 'custom_forms'" v-if="this.$store.state.user.enable_module_custom_forms && this.$root.hasPermission(['custom_forms.view', 'custom_forms.manage'])">
                        <i class="fa fa-check-square-o"></i> Custom Forms
                    </b-dropdown-item>
                    <b-dropdown-item @click="curTab = 'recognitions'" v-if="this.$root.hasPermission('recognitions.view')">
                        <i class="fa fa-trophy"></i> Recognitions
                    </b-dropdown-item>
                    <b-dropdown-item @click="curTab = 'history'">
                        <i class="fa fa-clock-o"></i> History
                    </b-dropdown-item>
                </b-nav-item-dropdown>
            </ul>

            <div class="mb-2 mb-lg-0 d-lg-none d-block">
                <b-dropdown :html="getTabTitle" variant="default" class="bg-white">
                    <b-dropdown-item :active="curTab === 'incidents'" @click="curTab = 'incidents'" v-if="this.$root.hasPermission(['incidents.view.browse', 'incidents.view.own'])">
                        <i class="fa fa-stethoscope"></i> Incidents
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'inspections'" @click="curTab = 'inspections'" v-if="this.$root.hasPermission(['inspections.view.browse', 'inspections.view.own'])">
                        <i class="fa fa-list"></i> Inspections ({{ insp_count }}) &amp; Observations ({{ obsv_count }})
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'equipment'" @click="curTab = 'equipment'" v-if="this.$root.hasPermission('equipment.view')">
                        <i class="fa fa-truck"></i> Equipment
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'jsa'" @click="curTab = 'jsa'" v-if="this.$root.hasPermission('jsa.view.browse')">
                        <i class="fa fa-files-o"></i> JSAs
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'meetings'" @click="curTab = 'meetings'" v-if="this.$root.hasPermission(['safety.meetings.view.browse', 'safety.meetings.view.own'])">
                        <i class="fa fa-life-ring"></i> Safety Meetings
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'data_sheets'" @click="curTab = 'data_sheets'" v-if="this.$root.hasPermission(['safety.data_sheets.view'])">
                        <i class="fa fa-files-o"></i> Safety Data Sheets ({{ sheet_count }})
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'employees'" @click="curTab = 'employees'" v-if="this.$root.hasPermission(['employees.view'])">
                        <i class="fa fa-group"></i> Employees <span v-if="emp_count">({{ emp_count }})</span>
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'insurance'" @click="curTab = 'insurance'">
                        <i class="fa fa-shield"></i> Insurance <span v-if="insurance_count">({{ insurance_count }})</span>
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'qr_code'" @click="curTab = 'qr_code'">
                        <i class="fa fa-qrcode"></i> QR Check In/Out
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'training_courses'" @click="curTab = 'training_courses'" v-if="this.$root.hasPermission(['training_courses.view'])">
                        <i class="fa fa-graduation-cap"></i> Training Courses
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'custom_forms'" @click="curTab = 'custom_forms'" v-if="this.$store.state.user.enable_module_custom_forms && this.$root.hasPermission(['custom_forms.view', 'custom_forms.manage'])">
                        <i class="fa fa-check-square-o"></i> Custom Forms
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'recognitions'" @click="curTab = 'recognitions'" v-if="this.$root.hasPermission('recognitions.view')">
                        <i class="fa fa-trophy"></i> Recognitions
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'history'" @click="curTab = 'history'">
                        <i class="fa fa-clock-o"></i> History
                    </b-dropdown-item>
                </b-dropdown>
            </div>

            <div class="card">
                <div class="card-body">
                    <div v-show="curTab === 'incidents'" v-if="this.$root.hasPermission(['incidents.view.browse', 'incidents.view.own'])">
                        <incident-list assetType="Jobsite" :assetId="parseInt(JobsiteId)" />
                    </div>

                    <div v-show="curTab === 'inspections'" v-if="this.$root.hasPermission(['inspections.view.browse', 'inspections.view.own'])">
                        <h5 class="text-muted">Inspections <span v-if="insp_count">({{ insp_count }})</span></h5>
                        <inspection-list assetType="Jobsite" :assetId="JobsiteId" @inspectionListCount="setInspCount" />

                        <h5 class="text-muted" style="margin-top: 40px">Observations <span v-if="obsv_count">({{ obsv_count }})</span></h5>
                        <observation-list assetType="Jobsite" :assetId="parseInt(JobsiteId)" :showExport="false" @obsvListCount="setObsvCount" :allowFilterSaving="false" />
                    </div>

                    <div v-show="curTab === 'equipment'" v-if="this.$root.hasPermission('equipment.view')">
                        <equipment-list assetType="Jobsite" :assetId="parseInt(JobsiteId)" />
                    </div>

                    <div v-show="curTab === 'jsa'" v-if="this.$root.hasPermission('jsa.view.browse')">
                        <template v-if="jobsite.percent_risk !== null">
                            <div class="row">
                                <div class="col-sm-6">
                                    <highcharts :options="options"/>
                                </div>
                                <div class="col-sm-6">
                                    <highcharts :options="gaugeOptions"/>
                                </div>
                            </div>
                            <hr/>
                        </template>
                        <jsa-list assetType="Jobsite" :assetId="JobsiteId" />
                    </div>

                    <div v-show="curTab === 'meetings'" v-if="this.$root.hasPermission(['safety.meetings.view.browse', 'safety.meetings.view.own'])">
                        <safety-meeting-list assetType="Jobsite" :assetId="JobsiteId" />
                    </div>

                    <div v-show="curTab === 'data_sheets'" v-if="this.$root.hasPermission(['safety.data_sheets.view'])">
                        <div class="card mb-4" v-if="jobsite.enable_sds_public_access == 1">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-8">
                                        <div class="row mb-3">
                                            <div class="col-md-3 text-muted text-md-right">SDS Link:</div>
                                            <div class="col-md-9">
                                                <a :href="sdsLink" target="_blank" title="View Public Access Library in a New Tab">{{ $root.appUrl }}{{ sdsLink }}</a>
                                            </div>
                                        </div>
                                        <div class="row mb-3" v-if="catalogs.length > 0">
                                            <div class="col-md-3 text-muted text-md-right">SDS Catalog Filter: <i class="fa fa-question-circle" title="If selected, the SDS Link will filter the files on the selected catagory and display the catagory name for the page title"></i></div>
                                            <div class="col-md-9">
                                                <b-form-select v-model="sds_catalog_id" :options="catalogOptions" />
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-md-3 text-muted text-md-right">SDS QR Code:</div>
                                            <div class="col-md-9">
                                                <qr-code ref="jobsiteSDSQrCode"
                                                    :qr_code_url="`${$root.appUrl}${sdsLink}`"
                                                    :qr_code_name="jobsite.JobsiteName+'-SDS-QR-Code'" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <safety-data-sheets-list assetType="Jobsite" :assetId="parseInt(JobsiteId)" :showAddBtn="true" @sdsListCount="setSdsCount"></safety-data-sheets-list>
                    </div>

                    <div v-show="curTab === 'employees'" v-if="this.$root.hasPermission(['employees.view'])">
                        <employee-list assetType="Jobsite" :assetId="parseInt(JobsiteId)" @empListCount="((count) => { emp_count = count; })"></employee-list>
                    </div>

                    <div v-show="curTab === 'insurance'">
                        <div class="mb-3">
                            <div class="row mb-4">
                                <div class="col-lg-2 text-muted text-md-right">
                                    Email Recipients <span v-if="jobsite.ins_alert_emails">({{ jobsite.ins_alert_emails.length }})</span>:

                                    <a href="javascript:void(0)" @click="edit_ins_emails = !edit_ins_emails" v-show="!edit_ins_emails && this.$root.hasPermission(['jobsites.manage'])">
                                        <i class="fa fa-edit"></i>
                                    </a>
                                </div>
                                <div class="col-md-6">
                                    <b-input-group v-if="edit_ins_emails">
                                        <b-form-input type="email" v-model="new_ins_email_recip" placeholder="Enter Email Recipient for Expiring Policy Alerts" />
                                        <b-input-group-append>
                                            <b-button variant="success" @click="addInsEmail()">
                                                <i class="fa fa-plus-circle"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>

                                    <ul class="list-unstyled" v-if="jobsite.ins_alert_emails">
                                        <li v-for="(email, i) in jobsite.ins_alert_emails">
                                            <a href="javascript:void(0)" v-if="edit_ins_emails" @click="deleteInsEmail(i)"><i class="fa fa-trash text-danger"></i></a> {{ email }}
                                        </li>
                                    </ul>

                                    <div class="mt-2" v-show="edit_ins_emails">
                                        <button type="button" class="btn btn-sm btn-success" @click="saveInsuranceEmails()" :disabled="saving_ins_emails">
                                            Save Emails <i class="fa fa-spin fa-spinner" v-if="saving_ins_emails"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-light" @click="edit_ins_emails = !edit_ins_emails" :disabled="saving_ins_emails">Cancel</button>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-2 text-muted text-md-right">
                                    Expiration Frequency <span v-if="jobsite.ins_alert_days">({{ jobsite.ins_alert_days.length }})</span>:

                                    <a href="javascript:void(0)" @click="edit_ins_alerts = !edit_ins_alerts" v-show="!edit_ins_alerts && this.$root.hasPermission('jobsites.manage')">
                                        <i class="fa fa-edit"></i>
                                    </a>
                                </div>
                                <div class="col-md-6">
                                    <b-input-group v-if="edit_ins_alerts">
                                        <b-form-input type="number" min="1" v-model="new_ins_alert_days" placeholder="Enter Number of Days Prior to the Expire Date to Send Email Alerts" />
                                        <b-input-group-append>
                                            <b-button variant="success" @click="addInsAlert()">
                                                <i class="fa fa-plus-circle"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>

                                    <ul class="list-unstyled" v-if="jobsite.ins_alert_days">
                                        <li v-for="(day, i) in jobsite.ins_alert_days">
                                            <a href="javascript:void(0)" v-if="edit_ins_alerts" @click="deleteInsAlert(i)"><i class="fa fa-trash text-danger"></i></a> {{ day }} Days Before Expiration
                                        </li>
                                    </ul>

                                    <div class="mt-2" v-show="edit_ins_alerts">
                                        <button type="button" class="btn btn-sm btn-success" @click="saveInsuranceAlerts()" :disabled="saving_ins_alerts">Save Frequencies</button>
                                        <button type="button" class="btn btn-sm btn-light" @click="edit_ins_alerts = !edit_ins_alerts" :disabled="saving_ins_alerts">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />

                        <jobsite-insurance-list :jobsiteId="JobsiteId" @JobsiteInsuranceListCount="((count) => { insurance_count = count; })" />
                    </div>

                    <div v-if="curTab === 'qr_code'">
                        <h5>
                            <i class="fa fa-qrcode"></i> QR Code Check In/Out
                        </h5>
                        <div class="row">
                            <div class="col-lg-5 col-md-6">
                                <qr-code
                                    :qr_code_url="`${$root.appUrl}/jobsites/check-in/${jobsite.sds_key}/${jobsite.JobsiteId}`"
                                    :qr_code_name="jobsite.JobsiteName"
                                    v-if="jobsite.JobsiteId && jobsite.sds_key"
                                    :show_url="true" />
                            </div>
                            <div class="col-lg-7 col-md-6">
                                <h4>How to use the Jobsite Check-In QR Code:</h4>
                                <p>This QR code points to an encrypted-style public check in page that allows any active employee with a valid Employee# to register their location at this jobsite.</p>
                                <p>Employees do not have to log in to do this, so it does not require a user license</p>
                                <p>In addition to their current jobsite, the timestamp will be captured when they check in.</p>

                                <div class="row mb-3">
                                    <div class="col-md-2 text-muted text-md-right test">Guest Check In:</div>
                                    <div class="col-md-9">
                                        <span class="badge badge-success" v-if="jobsite.enable_guest_check_in == 1">Enabled</span>
                                        <span class="badge badge-secondary" v-else>Disabled</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr/>

                        <jobsite-check-ins :jobsite_id="parseInt(JobsiteId)" />
                    </div>

                    <div v-show="curTab === 'training_courses'" v-if="this.$root.hasPermission(['training_courses.view'])">
                        <h5>
                            <i class="fa fa-graduation-cap"></i> Training Courses
                        </h5>
                        <employee-training-list :jobsiteId="parseInt(JobsiteId)" :showDistributeButton="true" :courseType="'Jobsite'"></employee-training-list>
                    </div>

                    <div v-show="curTab === 'custom_forms'" v-if="this.$store.state.user.enable_module_custom_forms && this.$root.hasPermission(['custom_forms.view', 'custom_forms.manage'])">
                        <h5>
                            <i class="fa fa-check-square-o"></i> Custom Forms
                        </h5>
                        <covid-list :jobsite_id="parseInt(JobsiteId)" />
                    </div>

                    <div v-show="curTab === 'recognitions'" v-if="this.$root.hasPermission('recognitions.view')">
                        <employee-recognition-list :assetId="parseInt(this.JobsiteId)" assetType="Jobsite" />
                    </div>

                    <div v-show="curTab === 'history'">
                        <history-list recordType="Jobsite" :recordId="parseInt(JobsiteId)" @historyCount="(total) => { this.history_count = total; }" />
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                show_avg_filters: false,
                loading_score: true,
                edit_ins_emails: false,
                edit_ins_alerts: false,
                saving_ins_emails: false,
                saving_ins_alerts: false,
                curTab: 'incidents',
                JobsiteId: this.$route.params.id,
                jobsite: {},
                totals: {},
                inspections: [],
                userTimezone: this.$store.state.user.timezone,
                labels: [],
                series: [],
                windowWidth: null,
                forms: [],
                catalogs: [],
                filterCount: 0,
                filters: {
                    InspectionFormId: null,
                    InspectionDate: null,
                },
                obsv_count: null,
                insp_count: null,
                sheet_count: null,
                sds_catalog_id: null,
                emp_count: null,
                insurance_count: null,
                history_count: null,
                new_ins_email_recip: null,
                new_ins_alert_days: null,
            }
        },

        computed: {
            gaugeOptions() {
                let size = '85%';
                if (this.windowWidth > 1600)
                    size = '150%';
                else if (this.windowWidth > 1550)
                    size = '140%';
                else if (this.windowWidth > 1500)
                    size = '130%';
                else if (this.windowWidth > 1450)
                    size = '120%';
                else if (this.windowWidth > 1400)
                    size = '110%';
                else if (this.windowWidth > 1350)
                    size = '100%';
                else if (this.windowWidth > 1300)
                    size = '90%';

                return {
                    chart: {
                        type: 'solidgauge'
                    },
                    title: {
                        text: 'Average RAC',
                    },
                    pane: {
                        center: ['50%', '90%'],
                        size: size,
                        clip: false,
                        startAngle: -90,
                        endAngle: 90,
                        background: {
                            // backgroundColor: '#EEE',
                            innerRadius: '50%',
                            outerRadius: '100%',
                            shape: 'arc'
                        }
                    },
                    tooltip: {enabled: false},

                    // the value axis
                    yAxis: {
                        stops: [
                            [0, '#27a94e'], // success
                            [1/3, '#ffc22b'], // warning
                            [2/3, '#ef871d'], // orange (custom)
                            [1, '#dc3045']  // danger
                        ],
                        lineWidth: 0,
                        minorTickInterval: 0,
                        tickPositioner: function() {
                            return [0, 33.333333, 66.666667, 100];
                        },
                        tickWidth: 1,
                        labels: {
                            enabled: true,
                            distance: 20,
                            formatter: function() {
                                if (this.value == 0)
                                    return 'Low';
                                else if (this.value <= Math.ceil(100/3))
                                    return 'Medium';
                                else if (this.value <= Math.ceil(200/3))
                                    return 'High';
                                else
                                    return 'Extremely<br>High';
                            }
                        },
                        min: 0,
                        max: 100
                    },
                    plotOptions: {
                        solidgauge: {
                            innerRadius: '50%',
                            dataLabels: {
                                y: 5,
                                borderWidth: 0,
                                useHTML: true
                            }
                        }
                    },
                    series: [{
                        data: [parseFloat(this.jobsite.percent_risk)],
                        dataLabels: {
                            formatter: function() {
                                let color;

                                if (this.y <= Math.ceil(100/6))
                                    color = 'text-success';
                                else if (this.y <= Math.ceil(300/6))
                                    color = 'text-warning';
                                else if (this.y <= Math.ceil(500/6))
                                    color = 'text-orange';
                                else
                                    color = 'text-danger';

                                let label;

                                if (this.y <= Math.ceil(100/6))
                                    label = 'Low';
                                else if (this.y <= Math.ceil(300/6))
                                    label = 'Medium';
                                else if (this.y <= Math.ceil(500/6))
                                    label = 'High';
                                else
                                    label = 'Extremely High';

                                return `<div style="text-align:center"><span style="font-size:25px;" class="${color}">${label}</span></div>`;
                            },
                        }
                     }]
                }
            },

            googleMap(){
                //Build the address
                var address = this.jobsite.Address + ' ' + (this.jobsite.Address2 ? this.jobsite.Address2 : '') + ' ' + this.jobsite.City + ', ' + this.jobsite.State + ' ' + this.jobsite.Zip;
                var apiKey = process.env.MIX_BASE_GOOGLE_MAPS_API;

                //Build the URL
                var baseUrl = 'https://www.google.com/maps/embed/v1/place?key='+apiKey+'&q='+encodeURI(address);

                //Send it
                return baseUrl;
            },

            options(){
                return {
                    chart: {
                        type: 'column'
                    },
                    title: {
                        text: 'JSA Hazards',
                    },
                    xAxis: {
                        categories: this.labels,
                    },
                    yAxis: {
                        title: {
                            text: '# of Hazards'
                        }
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                enabled: true,
                                formatter: function(){
                                    return this.point.series.name+': '+this.point.y;
                                }
                            }
                        }
                    },
                    legend: {
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom',
                        x: 0,
                        y: 0,
                        floating: false,
                        borderColor: '#dddddd',
                        borderWidth: 1
                    },
                    series: this.series
                }
            },

            getTabTitle(){
                //Setup
                var title = '';
                var icon = 'bars';

                //Switch
                switch(this.curTab)
                {
                    case 'incidents':
                        //Set
                        title = 'Incidents';
                        icon = 'stethoscope';
                        break;
                    case 'inspections':
                        //Set
                        title = 'Inspections & Observations';
                        icon = 'list';
                        break;
                    case 'insurance':
                        //Set
                        title = 'Insurance ('+this.insurance_count+')';
                        icon = 'shield';
                        break;
                    case 'equipment':
                        //Set
                        title = 'Equipment';
                        icon = 'truck';
                        break;
                    case 'jsa':
                        //Set
                        title = 'JSAs';
                        icon = 'copy';
                        break;
                    case 'meetings':
                        //Set
                        title = 'Safety Meetings';
                        icon = 'life-ring';
                        break;
                    case 'data_sheets':
                        //Set
                        title = 'Safety Data Sheets';
                        icon = 'copy';
                        break;
                }

                //Send it
                return '<i class="fa fa-'+icon+'"></i> ' + title;
            },

            catalogOptions(){
                //Setup
                var options = [
                    { value: null, text: '-- Select a Catalog to Filter SDS Link On --' },
                ];

                //Loop and Build
                for (var i = 0; i < this.catalogs.length; i++)
                {
                    //Append
                    options.push({value: this.catalogs[i].id, text: this.catalogs[i].catalog_name});
                }

                //Send it
                return options;
            },

            sdsLink(){
                //Setup
                var link = '/sds/key/'+this.jobsite.sds_key+'?jobsite='+this.jobsite.JobsiteNumber;

                //Check for Catalog ID
                if(this.sds_catalog_id)
                {
                    link += '&catalog_id=' + this.sds_catalog_id;
                }

                //Send it
                return link;
            },
        },

        watch: {
            'filters.InspectionFormId'(newVal, oldVal){
                //Recalculate the Avg
                this.getAvgInspectionScore();
                this.updateFilterCount();
            },

            'filters.InspectionDate'(newVal, oldVal){
                //Recalculate the Avg
                this.getAvgInspectionScore();
                this.updateFilterCount();
            },

            sds_catalog_id(newVal, oldVal){
                //Refetch the qr code
                this.$refs.jobsiteSDSQrCode.getQrCode();
            },
        },

        methods: {

            getJobsite() {
                //Get the data
                this.$http
                    .get(`jobsites/view/${this.JobsiteId}`)
                    .then(response => {
                        //Set all the data
                        this.jobsite = response.data;
                        this.forms = response.data.forms;
                        this.catalogs = response.data.catalogs;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });

                this.$http
                    .get(`jobsites/stats/${this.JobsiteId}`, [])
                    .then(response => {
                        //Check for length
                        if(response.data.series.length === 0)
                        {
                            //Alert the user
                            // this.$toastr.warning('There is no data for your currently selected filters.')

                            //Stop here
                            return;
                        }

                        //Set all the data
                        this.labels = response.data.labels;
                        this.series = response.data.series;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            getAvgInspectionScore() {
                //Show the loading indicator
                this.loading_score = true;

                //Send the response
                this.$http
                    .get(`jobsites/avg-inspection-score/${this.JobsiteId}`, this.filters)
                    .then(response => {
                        //Set all the data
                        this.totals = response.data;
                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //This is alway hit
                        this.loading_score = false;
                    });
            },

            updateFilterCount() {
                //Reset the count
                this.filterCount = 0;
                var status = false;

                // Loop over objects in this.filters
                for (var obj in this.filters) {

                    if (this.filters[obj] == null || this.filters[obj] === '') {
                        continue;
                    }

                    if (Array.isArray(this.filters[obj])) {
                        if (this.filters[obj].length > 0) {
                            this.filterCount++;
                        }
                        continue;
                    }

                    if (typeof this.filters[obj] === 'object') {
                        var Empty = true;
                        for (var key in this.filters[obj]) {
                            if (this.filters[obj].hasOwnProperty(key));
                            Empty = false;
                        }
                        if (!Empty) {
                            this.filterCount++;
                        }
                        continue;
                    }

                    if (typeof this.filters[obj] === 'string' || typeof this.filters[obj] === 'number') {
                        this.filterCount++;
                    }
                }
            },

            clearFilters() {
                //Reset each
                for (var columnName in this.filters) {
                    this.filters[columnName] = null;
                }

                this.$emit('filtersCleared', this.filters);

                //Update the count
                this.updateFilterCount();
            },

            setObsvCount(count){
                //Set the count
                this.obsv_count = count;
            },

            setInspCount(count){
                //Set the count
                this.insp_count = count;
            },

            setSdsCount(count){
                //Set the count
                this.sheet_count = count;
            },

            addInsEmail(){
                //Check Setup
                if(!this.jobsite.ins_alert_emails)
                {
                    this.jobsite.ins_alert_emails = [];
                }

                //Push it
                this.jobsite.ins_alert_emails.push(this.new_ins_email_recip);

                //Reset
                this.new_ins_email_recip = null;
            },

            deleteInsEmail(i){
                //Splice
                this.jobsite.ins_alert_emails.splice(i, 1);
            },

            addInsAlert(){
                //Check Setup
                if(!this.jobsite.ins_alert_days)
                {
                    this.jobsite.ins_alert_days = [];
                }

                //Push it
                this.jobsite.ins_alert_days.push(this.new_ins_alert_days);

                //Reset
                this.new_ins_alert_days = null;
            },

            deleteInsAlert(i){
                //Splice
                this.jobsite.ins_alert_days.splice(i, 1);
            },

            saveInsuranceEmails(){
                //Send it
                this.saving_ins_emails = true;

                //Get the data
                this.$http
                    .post(`jobsites/insurance/${this.JobsiteId}`, {'emails': this.jobsite.ins_alert_emails})
                    .then(response => {
                        //Reset
                        this.edit_ins_emails = false;

                        //Set loading
                        this.saving_ins_emails = false;
                    })
                    .catch(response => {

                    });
            },

            saveInsuranceAlerts(){
                //Send it
                this.saving_ins_alerts = true;

                //Get the data
                this.$http
                    .post(`jobsites/insurance/${this.JobsiteId}`, {'days': this.jobsite.ins_alert_days})
                    .then(response => {
                        //Reset
                        this.edit_ins_alerts = false;

                        //Set loading
                        this.saving_ins_alerts = false;
                    })
                    .catch(response => {

                    });
            },
        },

        mounted() {
            //Get the incidents
            this.getJobsite();
            this.getAvgInspectionScore();

            //Fix Width
            window.onresize = () => {
                this.windowWidth = window.innerWidth
            }
        }
    }
</script>
<style>
    .text-orange {
        color: #ef871d;
    }
</style>
